import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import _ from "lodash";
import GroundTruthChart from "../components/GroundTruthChart";
import Loading from "../components/Loading";
import Select from "../components/Select";
import GroundTruthFilter from "../components/filters/GroundTruthFilter";
import rem from "../utils/rem";

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - ${rem(60)});
`;

const ChartWrapper = styled.div`
  overflow: auto;
  flex-grow: 1;
  margin-left: 25px;
`;

const CollectionDateSelect = styled(Select)`
  width: 100px;
  margin-bottom: 10px;
`;

class GroundTruthContainer extends React.Component {
  componentDidMount() {
    this.props.rootStore.groundTruthStore.fetchData();
  }

  render() {
    const {
      rootStore: { groundTruthStore: store }
    } = this.props;

    return (
      <Wrapper>
        <GroundTruthFilter
          onChangeHandler={store.pushUrlParams}
          store={store}
        />
        <ChartWrapper>
          <h1>Ground Truth</h1>
          {!_.isEmpty(store.collectionDates) ? (
            <CollectionDateSelect
              name="ground-truth-collection-date"
              simpleValue
              options={store.collectionDates}
              value={store.get("collectionDate")}
              onChange={date => {
                store.update("collectionDate")(date);
                store.pushUrlParams();
              }}
              clearable={false}
            />
          ) : null}
          {store.isLoading ? (
            <Loading />
          ) : (
            <GroundTruthChart data={store.data} />
          )}
        </ChartWrapper>
      </Wrapper>
    );
  }
}

export default inject("rootStore")(observer(GroundTruthContainer));



// WEBPACK FOOTER //
// ./src/containers/GroundTruthContainer.js